import React from 'react';

import {
	useClassNames,
} from '@common';

import './DefaultTr.scss';

interface DefaultTrProps extends React.HTMLAttributes<HTMLTableRowElement>{
	test?: unknown,
}

function DefaultTr(props: DefaultTrProps): JSX.Element {
	const {
		children,
		className,
		...trProps
	} = props;

	const classes = useClassNames('table__row', className);

	return (
		<tr className={classes} {...trProps}>
			{children}
		</tr>
	);
}

const MemoisedDefaultTr = React.memo(DefaultTr);

export {MemoisedDefaultTr as DefaultTr};